import { render, staticRenderFns } from "./StaffNode.vue?vue&type=template&id=0f13dd0b&scoped=true"
import script from "./StaffNode.vue?vue&type=script&lang=js"
export * from "./StaffNode.vue?vue&type=script&lang=js"
import style0 from "./StaffNode.vue?vue&type=style&index=0&id=0f13dd0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f13dd0b",
  null
  
)

export default component.exports